import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';

import { FormsModule } from '@angular/forms';
import {
  isOperatorRole,
  NO_PUBLISHED_VERSIONS_MESSAGE,
} from '../../shared/helpers/version-visibility.helper';

export interface EditRoleDialogData {
  userName: string;
  currentRoleId: number;
  roles: {
    id: number;
    name: string;
  }[];
  canAssignOperatorRole?: boolean;
  operatorRoleBlockedMessage?: string;
}

@Component({
  selector: 'app-edit-role-dialog',
  templateUrl: './edit-role-dialog.component.html',
  styleUrls: ['./edit-role-dialog.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    MatIconModule,
    MatFormFieldModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditRoleDialogComponent {
  dialogRef = inject<MatDialogRef<EditRoleDialogComponent>>(MatDialogRef);
  data = inject<EditRoleDialogData>(MAT_DIALOG_DATA);

  selectedRoleId: number;
  readonly defaultOperatorBlockedMessage = NO_PUBLISHED_VERSIONS_MESSAGE;

  constructor() {
    const data = this.data;

    this.selectedRoleId = data.currentRoleId;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    const selectedRole = this.data.roles.find(
      (role) => role.id === this.selectedRoleId,
    );
    if (selectedRole && this.isRoleDisabled(selectedRole)) {
      return;
    }

    this.dialogRef.close({ roleId: this.selectedRoleId });
  }

  isRoleDisabled(role: { id: number; name: string }): boolean {
    return (
      isOperatorRole(role.name) && this.data.canAssignOperatorRole === false
    );
  }

  getOperatorRoleBlockedMessage(): string {
    return (
      this.data.operatorRoleBlockedMessage || this.defaultOperatorBlockedMessage
    );
  }
}
